import * as React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useParams } from 'react-router';
import { SectionContact } from '../layout/SectionContact';
import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { Container } from '../layout/Container';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import { SectionServices } from '../layout/SectionServices';
import { PageContentType } from '../../../server/global/enum';
import { ModalContext } from '../ui/modal/modal';

//GraphQL
import { useQuery } from '@apollo/client';
import {
  Query,
  QueryGetPageContentInputArgs,
} from '../../../client/types/generated/types';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';
import { Heading } from '../ui/text/Heading';
import { CloseIcon } from '../ui/icons/Close';
import { LogoSmall } from '../ui/logo/LogoSmall';
import { NewsLetter } from '../ui/modal/types/NewsLetter';
import { remove } from 'winston';
import { useInlineLink } from '../../utils/hooks/useInlineLink';

export const PortalNewsStyle = styled.div`
  padding-top: 6em;
`;

type GetPageItem = Pick<Query, 'getNdPageContent'>;

const NewsPortal: React.FC = () => {
  const { showModal } = React.useContext(ModalContext);
  const params = useParams<{ urltag: string }>();
  const { data } = useQuery<GetPageItem, QueryGetPageContentInputArgs>(
    CONTENT_ITEM,
    {
      skip: !params.urltag,
      fetchPolicy: 'network-only',
      variables: {
        input: { urltag: params.urltag, type: PageContentType.NEWS },
      },
    }
  );

  useInlineLink({
    targetId: 'newslettermodal',
    onClick: () => {
      showModal({ component: <NewsLetter /> });
    },
  });

  /* Erstatter a tag i admin panel med en klikkbar link   */
  const replace = (str: any) => {
    if (str?.match(/@nyhetsbrev/)) {
      return str.replace(
        /@nyhetsbrev/,
        "<a id='newslettermodal' href='#'>nyhetsbrev</a>"
      );
    } else {
      return str;
    }
  };

  return (
    <>
      <Seo
        title={`Nyheter - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        image={
          data?.getNdPageContent?.seo?.image
            ? data?.getNdPageContent?.seo?.image
            : undefined
        }
        description={
          data?.getNdPageContent?.seo?.text
            ? data?.getNdPageContent?.seo?.text
            : undefined
        }
      />
      <Page>
        <PortalNewsStyle>
          <SectionInfoNarrow
            title={data?.getNdPageContent?.title}
            info={replace(data?.getNdPageContent?.text)}
            hidebackground
          />

          <SectionNewsCard limit={12} />
          {data?.getNdPageContent?.config?.showSubpageServices ? (
            <SectionServices />
          ) : null}

          {data?.getNdPageContent?.config?.showSubpageContact ? (
            <SectionContact />
          ) : null}
        </PortalNewsStyle>
      </Page>
    </>
  );
};

export default NewsPortal;
